// extracted by mini-css-extract-plugin
export default {"container":"rangeSliderComponent_container__7-YMg","rangeSlider":"rangeSliderComponent_rangeSlider__hEEXH"};